import LogoLarge from "./LogoLarge";

export default LogoLarge